import { BehaviorSubject } from "rxjs";
export const lineupSearchTerm = new BehaviorSubject("");
